
    // this file was auto generated by python script
    import Slack from './Slack';
    export default Slack;
    